import { useEffect, useState } from 'react';
import { useLocation, useParams } from '@tanstack/react-router';
import TeamNavigation from './TeamNavigation';
import FooterNavigation from './FooterNavigation';
import { useCaseContext } from '@/components/contexts/CaseContext';
import { cn } from '@/lib/utils';

interface NavigationProps {
  collapsed?: boolean;
}

const Navigation = ({ collapsed = false }: NavigationProps) => {
  const location = useLocation();
  const { slug } = useParams({ strict: false });
  const [activePathname, setActivePathname] = useState<null | string>(null);
  const { selectedCase, setSelectedCase } = useCaseContext();

  useEffect(() => {
    if (typeof slug === 'string' && slug && slug !== 'undefined') {
      setSelectedCase(slug);
    }
  }, [slug, setSelectedCase]);

  useEffect(() => {
    if (location.pathname) {
      setActivePathname(location.pathname);
    }
  }, [location.pathname]);

  const matterSlug = (typeof slug === 'string' && slug && slug !== 'undefined')
    ? slug
    : selectedCase;

  const NavigationComponent = () => {
    return <TeamNavigation activePathname={activePathname} slug={matterSlug} collapsed={collapsed} />;
  };

  return (
    <nav className={cn(
      "flex flex-col justify-between flex-1 min-h-0",
      collapsed ? "items-center" : ""
    )}>
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        <NavigationComponent />
      </div>
      <div className={cn(
        'shrink-0 border-t border-white/10 pt-2 pb-2',
        collapsed ? "w-full" : ""
      )}>
        <FooterNavigation activePathname={activePathname} slug={matterSlug} collapsed={collapsed} />
      </div>
    </nav>
  );
};

export default Navigation;
